<template>
  <v-icon v-bind="$attrs">fas fa-{{icon}}</v-icon>
</template>

<script>
export default {
  props: ["icon"]
};
</script>